import { Component, ContentChild, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from "@angular/core";

@Component({
  selector: "app-carousel",
  templateUrl: "./carousel.component.html",
  styleUrls: ["./carousel.component.scss"],
})
export class CarouselComponent<T = any> implements OnChanges {
  @Input() items: T[] = [];
  @Input() itemsPerView = 2;

  @Output() itemViewed = new EventEmitter<T>();

  currentSlideIndex = 0;

  @ContentChild(TemplateRef) itemTemplate!: TemplateRef<any>;

  /**
   * Reset slide index whenever items changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["items"]) {
      this.currentSlideIndex = 0;

      queueMicrotask(() => {
        this.emitShown();
      });
    }
  }

  /**
   * Returns currently visible items for carousel
   * @return itemsPerView items starting from current index
   */
  get visibleItems(): T[] {
    return this.items.slice(this.currentSlideIndex, this.currentSlideIndex + this.itemsPerView);
  }

  /**
   * Calculates number of carousel slides
   * @return total number of slides
   */
  public get totalSlides(): number {
    return Math.ceil(this.items.length / this.itemsPerView);
  }

  /**
   * Returns slide indices for pagination dots
   * @return array of slide indexes
   */
  public get slideIndices(): number[] {
    return Array.from({ length: this.totalSlides }, (_, i) => i);
  }

  /**
   * Moves carousel to previous slide
   */
  public nextSlide(): void {
    if (this.currentSlideIndex + this.itemsPerView < this.items.length) {
      this.currentSlideIndex += this.itemsPerView;
      this.emitShown();
    }
  }

  /**
   * Moves carousel to new slide
   */
  public prevSlide(): void {
    if (this.currentSlideIndex >= this.itemsPerView) {
      this.currentSlideIndex -= this.itemsPerView;
      this.emitShown();
    }
  }

  /**
   * Moves carousel to specific slide
   * @param i slide index
   */
  public goToSlide(i: number): void {
    this.currentSlideIndex = i * this.itemsPerView;
    this.emitShown();
  }

  private emitShown(): void {
    this.visibleItems.forEach((item) => this.itemViewed.emit(item));
  }
}
